import { combineSlices, compose, configureStore } from '@reduxjs/toolkit';
import persistState from 'redux-sessionstorage';

import { announcementApi } from './api/announcementApi';

import socketMiddleware from 'services/socketMiddleware';
import { agoraMonitorApi } from 'store/api/agoraMonitorApi';
import { auctionApi } from 'store/api/auctionApi';
import { authApi } from 'store/api/authApi';
import { claimApi } from 'store/api/claimApi';
import { clientApi } from 'store/api/clientApi';
import { goLiveApi } from 'store/api/goLiveApi';
import { intakeCaseApi } from 'store/api/intakeCaseApi';
import { ndpApi } from 'store/api/ndpApi';
import { notificationApi } from 'store/api/notificationApi';
import { onboardingApi } from 'store/api/onboardingApi';
import { opportunityCuratorApi } from 'store/api/opportunityCuratorApi';
import { payerRequestApi } from 'store/api/payerRequestApi';
import { pbmApi } from 'store/api/pbmApi';
import { performanceApi } from 'store/api/performanceApi';
import { rateSetterApi } from 'store/api/rateSetterApi';
import { referenceApi } from 'store/api/referenceApi';
import { scopeAssessorApi } from 'store/api/scopeAssessorApi';
import { treatmentApi } from 'store/api/treatmentApi';
import { treatmentAuditApi } from 'store/api/treatmentAuditApi';
import { userSupportApi } from 'store/api/userSupportApi';
import { xComApi } from 'store/api/xComApi';
import { authSlice } from 'store/auth/authSlice';
import { referralChecklistSlice } from 'store/checklist/referralChecklistSlice';
import { gridsSlice } from 'store/grids/gridsSlice';
import { notificationSlice } from 'store/notification/notificationSlice';
import { opportunitiesSlice } from 'store/opportunities/opportunitiesSlice';
import { referralsSlice } from 'store/referrals/referralsSlice';
import { testReferralSlice } from 'store/testReferral/testReferralSlice';
import { treatmentSlice } from 'store/treatment/treatmentSlice';
import { userSupportSlice } from 'store/userSupport/userSupportSlice';

const sessionStorageEnhancer = compose(persistState(gridsSlice.name, { key: 'agoraStore' }));

const slices = [
    authSlice,
    gridsSlice,
    notificationSlice,
    opportunitiesSlice,
    referralChecklistSlice,
    referralsSlice,
    testReferralSlice,
    treatmentSlice,
    userSupportSlice,
];

const apiSlices = [
    agoraMonitorApi,
    announcementApi,
    authApi,
    auctionApi,
    claimApi,
    clientApi,
    goLiveApi,
    intakeCaseApi,
    ndpApi,
    notificationApi,
    onboardingApi,
    opportunityCuratorApi,
    payerRequestApi,
    pbmApi,
    performanceApi,
    rateSetterApi,
    referenceApi,
    scopeAssessorApi,
    treatmentApi,
    treatmentAuditApi,
    userSupportApi,
    xComApi,
];

const rootReducer = combineSlices(...slices, ...apiSlices);

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(
            socketMiddleware,
            apiSlices.map((slice) => slice.middleware),
        ),
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sessionStorageEnhancer),
    devTools: process.env.REACT_APP_ENV !== 'prd',
});

/** Used for configuration of redux store in tests */
export const MockStore = {
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(
            socketMiddleware,
            apiSlices.map((slice) => slice.middleware),
        ),
};
